(ns app.front.view.contact-request.public-view
  (:require [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.radio :as ui-radio]
            [app.front.ui.section :as section]
            [app.front.util :as futil]
            [app.front.view.landing-page :as landing-page]
            [core.domain.validators :as validators]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::init
  (fn [{:keys [db]} [_ branding]]
    {:db           (assoc db ::data {})
     :comm/command {:command    :public-records/config
                    :method     :get
                    :data       {:branding branding}
                    :on-success [::init.success]}}))

(rf/reg-event-db ::init.success
  (fn [db [_ _ config]]
    (assoc-in db [::data ::config] config)))

(rf/reg-event-fx ::leave
  (fn [{:keys [db]} _]
    {:db (dissoc db ::data)}))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::submitted?
  :<- [::data]
  :-> ::submitted?)

(rf/reg-sub ::config
  :<- [::data]
  :-> ::config)

(rf/reg-event-db ::save-attr
  (fn [db [_ attr value]]
    (assoc-in db [::data ::contact-request-data attr] value)))

(rf/reg-sub ::contact-request-data
  (fn [db [_ attr]]
    (get-in db (remove nil? [::data ::contact-request-data attr]))))

(rf/reg-event-fx ::cancel-editing
  (fn [_ _]
    {:dispatch [:route/push :view/landing-page]}))

(rf/reg-event-fx ::send-contact-request.success
  (fn [{:keys [db]} _]
    {:db             (-> db
                         (assoc-in [::data ::submitted?] true)
                         (update ::data dissoc ::contact-request-data))
     :dispatch-later {:ms       3000
                      :dispatch [:route/push :view/landing-page]}}))

(rf/reg-event-fx ::send-contact-request
  (fn [{:keys [db]} [_ domain-group]]
    {:comm/command {:command    :public-map/contact-request
                    :data       (-> db
                                    ::data
                                    ::contact-request-data
                                    (assoc :domain-group-id (:group/id domain-group)))
                    :method     :post
                    :notify     {:success :public-map-view/contact-request-submitted}
                    :on-success [::send-contact-request.success]}}))

(rf/reg-sub ::save-disabled?
  :<- [::contact-request-data]
  (fn [contact-request-data]
    (not (and (:contact-request/details contact-request-data)
              (:contact-request/fullname contact-request-data)
              (:contact-request/contact-by contact-request-data)
              (:contact-request/phone contact-request-data)
              (validators/valid-email? (:contact-request/email contact-request-data))))))

(defn contact-request-form [tr]
  (let [domain-group (:domain-group (<sub [::config]))]
    [:div.p-5
     [ui/text-area {:data-cy     "contact-request-content"
                    :label-text  (tr [:public-map-view/contact-request-details])
                    :input-class "h-full"
                    :required    true
                    :value       (<sub [::contact-request-data :contact-request/details])
                    :on-change   #(>evt [::save-attr :contact-request/details (futil/tval %)])}]
     [:div.mt-5.flex.flex-col.lg:flex-row.lg:gap-5
      [:div.flex-1
       [ui/text-input
        {:id         "contact-request-name"
         :value      (<sub [::contact-request-data :contact-request/fullname])
         :label-text (tr [:public-map-view/contact-request-name])
         :required   true
         :on-change  #(>evt [::save-attr :contact-request/fullname (futil/tval %)])}]]
      [:div.flex-1
       [ui/text-input
        {:id         "contact-request-email"
         :value      (<sub [::contact-request-data :contact-request/email])
         :label-text (tr [:public-map-view/contact-request-email])
         :required   true
         :on-change  #(>evt [::save-attr :contact-request/email (futil/tval %)])}]]]
     [:div.mt-5.flex.flex-col.lg:flex-row.lg:gap-5
      [:div.flex-1
       [ui/intl-tel-input {:id              "contact-request-phone"
                           :type            :text
                           :label-text      (tr [:public-map-view/contact-request-phone])
                           :placeholder     (tr [:placeholder/international-phone])
                           :required        true
                           :value           (<sub [::contact-request-data :contact-request/phone])
                           :callback        #(rf/dispatch-sync [::save-attr :contact-request/phone %])
                           :initial-country (<sub [::front-config/country])}]]
      [:div.flex-1
       [ui-radio/radio {:name       "contact-me-by"
                        :label-text (tr [:public-map-view/contact-request-contact-by])
                        :values     [:email :phone]
                        :required   true
                        :value      (<sub [::contact-request-data :contact-request/contact-by])
                        :val->str   (comp tr vector (partial keyword "public-map-view"))
                        :on-change  #(>evt [::save-attr :contact-request/contact-by %])}]]]
     [:div.mt-5
      [ui-action-buttons/save-cancel-buttons
       {:on-cancel      #(>evt [::cancel-editing])
        :on-save        #(>evt [::send-contact-request domain-group])
        :save-tr        (tr [:public-map-view/submit])
        :save-disabled? (<sub [::save-disabled?])
        :size           :small
        :tr             tr}]]]))

(defn- view [_match]
  (let [tr         (<sub [:tr])
        loading?   (<sub [:comm/command-processing? :public-records/config])
        submitted? (<sub [::submitted?])]
    (if loading?
      [:div.cloudpermit-page
       [section/section-skeleton]]
      [:div.cloudpermit-page
       [ui/page-header {}
        [:h1.bold (tr [:public-map-view/contact-request])]]
       (if submitted?
         [:section
          [:h2.text-2xl.font-bold.mb-4 (tr [:public-map-view/contact-request-submitted])]]
         [:section
          [contact-request-form tr]])])))

(rf/reg-sub ::view-data
  :<- [:session/logged-in?]
  (fn [logged-in? _]
    {:back-href (href/href (if logged-in?
                             :dashboard
                             :view/landing-page))}))

(def route
  {:name          :view/create-contact-request
   :view          view
   :view-sub      [::view-data]
   :public-header landing-page/landing-header
   :public?       true
   :parameters    {:path {:branding s/Str}}
   :controllers   [{:parameters {:path [:branding]}
                    :start      (fn [{{:keys [branding]} :path}]
                                  (>evt [::init branding])
                                  (>evt [::landing-page/init branding]))
                    :stop       (fn [_]
                                  (>evt [::leave]))}]})
